import {
    asyncRouterMap,
    constantRouterMap
  } from 'src/router'
  import {
    fetchAll
  } from 'api/admin/menu/index';
  /**
   * 通过authority判断是否与当前用户权限匹配
   * @param menus
   * @param route
   */
  function hasPermission(menus, route) {
    // console.log(route);
    if (route.authority) {
      if (menus[route.authority] !== undefined) {
        // console.log(menus);
        // console.log(menus[route.authority]);
        return menus[route.authority];
      } else {
        // console.log(menus);
        return false;
      }
    } else {
      return true
    }
  }
  
  /**
   * 递归过滤异步路由表，返回符合用户角色权限的路由表
   * @param asyncRouterMap
   * @param roles
   */
  function filterAsyncRouter(asyncRouterMap, menus, menuDatas) {
    const accessedRouters = asyncRouterMap.filter(route => {
      if (hasPermission(menus, route)) {
        if (localStorage.getItem('locale') == 'zh_cn') {
          // console.log('menuDatas',menuDatas)
          // console.log('menuDatas[route.authority]',menuDatas[route.authority])
          route.name = menuDatas[route.authority].title;
        } else if (localStorage.getItem('locale') == 'zh_tw') {
          route.name = menuDatas[route.authority].attr7;
        } else {
          route.name = menuDatas[route.authority].attr8;
        }
        route.icon = menuDatas[route.authority].icon;
  
        // if( localStorage.getItem('userType') == '5' ){
        //   if( route.name == '人员管理' || route.name == '人員管理' || route.name == "Personnel" ){
        //     route = {};
        //     return;
        //   } 
        // }
  
        if (localStorage.getItem('userType') == '2' && localStorage.getItem('grade') !== '1') {
          // if (route.name == '分润' || route.name == "分潤" || route.name == 'Profit' || route.name == '资金管理' || route.name == "資金管理" || route.name == 'Fund') {
          if( ['分润','分潤','Profit','资金管理',"資金管理",'Fund'].includes( route.name ) ){
            route = {};
            return;
          }
        }
  
        if (localStorage.getItem('companyId') == '2') {
          // if ( route.name == "待审核兑现" || route.name == "待審批兌現" ||  route.name == "Withdrawal" || route.name == '公司' || route.name == "Company" || route.name == '公司审核' || route.name == "公司審批" || route.name == '兑现' || route.name == "兌現" || route.name == 'Withdrawal' || route.name == '分润' || route.name == "分潤" || route.name == 'Profit') {
          if( ['待审核兑现','待審批兌現','Withdrawal','公司',"Company",'公司审核','公司審批','兑现','兌現','Withdrawal','分润','分潤','Profit'].includes( route.name ) ){
            route = {};
            return;
          }
        }

        // if (localStorage.getItem('companyId') == '3') {
        //   // 澳门机构所有角色没有财务权限
        //   if( ['财务','財務','Finance','风险控制','風險控制','Risk Control','兑现审核','兌現審批','Withdrawal'].includes( route.name ) ){
        //     route = {};
        //     return;
        //   }

        //   if( localStorage.getItem('userType') == '5' ){
        //     if( ['意见管理','意见管理','Feedback','通知管理',"通告管理",'Notification','代理商审核','代理商審核','Agent','待审核兑现','待審批兌現','Withdrawal'].includes( route.name ) ){
        //       route = {};
        //       return;
        //     }
        //   }
        // }

        if (localStorage.getItem('companyId') == '3') {
          // 澳门机构所有角色没有财务权限
          if( ['财务','財務','Finance','风险控制','風險控制','Risk Control'].includes( route.name ) ){
            route = {};
            return;
          }

          if( localStorage.getItem('userType') == '5' ){
            if( ['意见管理','意見管理','Feedback','通知管理',"通告管理",'Notification','代理商审核','代理商審核','Agent_Audit','兑现审核','兌現審批','Withdrawal_Approval'].includes( route.name ) ){
              route = {};
              return;
            }
          }
        }
  
        if (route.children && route.children.length) {
          route.children = filterAsyncRouter(route.children, menus, menuDatas);
        }
        return true
      }
      return false
    })
    // console.log(menus);
    // console.log(accessedRouters);
    return accessedRouters
  }
  
  const permission = {
    state: {
      routers: constantRouterMap,
      addRouters: []
    },
    mutations: {
      SET_ROUTERS: (state, routers) => {
        state.addRouters = routers
        state.routers = constantRouterMap.concat(routers).filter(element => {
          return element.authority
        });
      }
    },
    actions: {
      GenerateRoutes({
        commit
      }, menus) {
        return new Promise(resolve => {
          // const accessedRouters = filterAsyncRouter(asyncRouterMap, menus);
          // commit('SET_ROUTERS', accessedRouters);
          // resolve();
          fetchAll().then(data => {
            const menuDatas = {};
            //        console.log(data)
            for (let i = 0; i < data.length; i++) {
              menuDatas[data[i].code] = data[i];
              //          console.log('菜单')
              //          console.log(menuDatas)
            }
            let accessedRouters = filterAsyncRouter(asyncRouterMap, menus, menuDatas);
  
            accessedRouters = accessedRouters.filter(element => {
              return element.authority
            })
  
            commit('SET_ROUTERS', accessedRouters);
            resolve();
          });
        })
      }
    }
  };
  
  export default permission;
  


// WEBPACK FOOTER //
// ./src/store/modules/permission.js